export default {
    title: "Catalog",

    noAvailableItems: "No products available to order."
}